import{nothing as r}from"lit";function t(t,o=t,i=r){return t?o:i}export{t as c};
//# sourceMappingURL=cond-CI1KbneT.js.map
